import type { NavigateOptions } from "@tanstack/react-router";
import { useNavigate } from "@tanstack/react-router";
import { useStore } from "@/store";

export const useAppNavigate = () => {
  const navigate = useNavigate();
  const { activeProvinceId } = useStore();

  return (options: NavigateOptions) => {
    navigate({
      search: {
        province: options.to === "/" ? undefined : activeProvinceId,
      },
      ...options,
    });
  };
};
